// Enviar por paqueteria (Skydropx) · pantalla de Mi panel 2.0.
//
// EL ORDEN REAL: la clienta cierra su pedido, le damos el total y DESPUES pregunta si se lo
// podemos mandar; ahi manda su direccion por WhatsApp. Por eso esto se abre desde un pedido YA
// ENVIADO, y por eso lo primero de la pantalla es "pega el mensaje de la clienta".
//
// LO QUE NO SE LE TECLEA A LA VENDEDORA: estado, municipio y colonia salen del catalogo de
// Skydropx a partir del codigo postal. No es comodidad: cualquier otra ortografia hace que su
// cotizador responda 422, y de pasada esos nombres son los mismos que usa Odoo, asi que la
// direccion se guarda en el cliente sin traducir nada.
//
// LA GUIA SIGUE SIENDO MANUAL (decision del dueno): la paqueteria depende de cosas que no estan
// en el sistema. Esta pantalla deja el pedido cargado en Skydropx para que solo elija y de un
// clic, y despues trae el numero de guia de regreso.
import React from 'react';
import RastreoEnvio from './RastreoEnvio.jsx';
import EnvioClienta from './EnvioClienta.jsx';
const { useState, useEffect, useMemo, useRef } = React;

const CSS = `
.ep-tar{display:flex;flex-direction:column;gap:8px;margin-top:10px}
.ep-t{display:flex;align-items:center;gap:12px;width:100%;text-align:left;background:#FFFFFF;border:1px solid #E2E8F0;padding:12px;cursor:pointer}
.ep-t.on{border-color:#111827;box-shadow:inset 0 0 0 1px #111827}
.ep-t .d{flex:1;min-width:0}
.ep-t .d b{display:block;font-size:14px;line-height:1.3}
.ep-t .d small{display:block;color:#64748B;font-size:12px;margin-top:2px}
.ep-t .p{text-align:right;flex-shrink:0}
.ep-t .p b{display:block;font-size:15px}
.ep-t .p small{display:block;color:#64748B;font-size:11px}
.ep-dias{flex-shrink:0;width:46px;text-align:center}
.ep-dias b{display:block;font-size:18px;line-height:1}
.ep-dias small{display:block;font-size:10px;color:#64748B;letter-spacing:.5px}
.ep-row{display:flex;gap:10px}
.ep-row>*{flex:1;min-width:0}
.ep-ro{width:100%;min-height:50px;border:1px solid #E2E8F0;background:#F8FAFC;color:#475569;padding:14px 12px;font-size:15px}
.ep-ta{width:100%;min-height:92px;border:1px solid var(--ink,#111827);padding:12px;font-size:16px;outline:none;background:#FFFFFF;font-family:inherit;resize:vertical}
.ep-nota{font-size:12px;color:#64748B;margin:6px 0 0;line-height:1.45}
.ep-ok{background:#E6F4EA;border:1px solid #1D8A4E;color:#14532D;padding:12px;font-size:13px;line-height:1.5;margin-top:12px}
.ep-guia{background:#FFFFFF;border:1px solid #E2E8F0;padding:14px;margin-top:12px}
.ep-guia b{font-size:18px;letter-spacing:1px;display:block;margin-top:4px}
.ep-paso{font-size:11px;letter-spacing:2px;color:#94A3B8;font-weight:600;margin:22px 0 0}
.ep-saldo{display:flex;align-items:baseline;justify-content:space-between;gap:10px;background:#F8FAFC;border:1px solid #E2E8F0;padding:10px 12px;font-size:12px;color:#475569}
.ep-saldo b{font-size:15px;color:#0F172A}
.ep-saldo.bajo{background:#FEF3C7;border-color:#D97706;color:#78350F}
.ep-saldo.bajo b{color:#78350F}
.ep-row3{display:flex;gap:8px}
.ep-row3>*{flex:1;min-width:0}
.falta{border-color:#B91C1C !important;box-shadow:inset 0 0 0 1px #B91C1C}
.ep-falta{display:block;color:#B91C1C;font-size:12px;margin-top:4px}
.ep-chips{display:flex;flex-wrap:wrap;gap:6px;margin-top:6px}
.ep-chip{font-size:11px;line-height:1.5;padding:1px 7px;border:1px solid #CBD5E1;color:#475569;background:#F8FAFC;border-radius:10px;white-space:nowrap}
.ep-chip.ojo{border-color:#D97706;background:#FEF3C7;color:#78350F}
.ep-suc{border:1px solid #D97706;background:#FFFBEB;padding:12px;margin-top:10px}
.ep-suc h4{margin:0 0 2px;font-size:13px;color:#78350F}
.ep-suc .op{display:flex;gap:8px;margin:10px 0 4px}
.ep-suc .op button{flex:1;padding:9px 6px;font-size:12px;border:1px solid #CBD5E1;background:#FFFFFF;color:#475569;cursor:pointer}
.ep-suc .op button.on{border-color:#111827;color:#0F172A;font-weight:600}
.ep-s{display:block;width:100%;text-align:left;background:#FFFFFF;border:1px solid #E2E8F0;padding:10px;margin-top:6px;cursor:pointer}
.ep-s.on{border-color:#111827;box-shadow:inset 0 0 0 1px #111827}
.ep-seg{display:flex;align-items:center;justify-content:space-between;gap:12px;border:1px solid #E2E8F0;background:#FFFFFF;padding:12px;margin-top:16px}
.ep-seg .t b{display:block;font-size:14px}
.ep-seg .t small{display:block;color:#64748B;font-size:12px;margin-top:2px}
.ep-sw{flex-shrink:0;width:50px;height:30px;border-radius:15px;border:1px solid #CBD5E1;background:#E2E8F0;position:relative;cursor:pointer;padding:0}
.ep-sw .b{position:absolute;top:2px;left:2px;width:24px;height:24px;border-radius:12px;background:#FFFFFF;box-shadow:0 1px 3px rgba(0,0,0,.25);transition:left .15s}
.ep-sw.on{background:#111827;border-color:#111827}
.ep-sw.on .b{left:22px}
.ep-s b{display:block;font-size:13px}
.ep-s small{display:block;color:#64748B;font-size:12px;margin-top:2px;line-height:1.4}
.ep-cob{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-top:10px;padding-top:10px;border-top:1px solid #E2E8F0}
.ep-cob small{display:block;color:#64748B;font-size:12px}
.ep-cob b{font-size:16px;letter-spacing:0;display:inline;margin:0}
.ep-cob .c2-btn{width:auto;padding:8px 14px;font-size:13px;min-height:0}
`;

// Tipos de empaque. Los codigos son los de la Carta Porte del SAT, que es lo que Skydropx pide
// (c_TipoEmbalaje): verificados el 20-oct en su propia lista. NO son inventados, y algunas
// paqueterias cotizan distinto segun el tipo. "Tarima" no existe en ese catalogo, asi que va
// como "Otro" y se dice en la pantalla en vez de mandar un codigo fiscal falso.
const EMPAQUES = [
  { codigo: '4G',  nombre: 'Caja de cartón' },
  { codigo: '4H2', nombre: 'Caja de plástico rígido' },
  { codigo: '5H4', nombre: 'Saco (bolsa) de plástico' },
  { codigo: '5M1', nombre: 'Saco (bolsa) de papel' },
  { codigo: '7H1', nombre: 'Bulto de plástico' },
  { codigo: 'Z01', nombre: 'Otro (tarima, empaque distinto)' },
];

// Que va dentro de la caja, para la Carta Porte. Son codigos del catalogo del SAT que Skydropx
// pide al generar la guia; salieron de su propio endpoint /shipments/consignment_notes, no
// inventados. No hay un codigo general de "ropa": se declara lo que predomina en la caja.
const MERCANCIAS = [
  { codigo: '53101600', nombre: 'Faldas y blusas' },
  { codigo: '53101500', nombre: 'Pantalones' },
  { codigo: '53102000', nombre: 'Vestidos' },
  { codigo: '53101700', nombre: 'Suéteres' },
  { codigo: '53101800', nombre: 'Abrigos y chamarras' },
  { codigo: '53102300', nombre: 'Ropa interior' },
  { codigo: '53102500', nombre: 'Accesorios de vestir' },
];

// Como la recibe la clienta y como se le entrega el paquete a la paqueteria.
const ENTREGA = {
  domicilio: 'Se la llevan a su casa',
  sucursal: 'Ella va por él a sucursal',
  ambas: 'A su casa o a sucursal',
};
const RECOLECCION = {
  si: 'Pasan por el paquete',
  no: 'Tú lo llevas',
  soporte: 'Recolección pidiéndola a soporte',
};

const digitos = s => String(s || '').replace(/\D/g, '');
// Los datos sin los que no se puede mandar el paquete, con el nombre que se le dice a la
// vendedora. Fuera del componente porque no cambia nunca.
const CAMPOS = [
  ['cp', 'el código postal'],
  ['colonia', 'la colonia'],
  ['calle', 'la calle y el número'],
  ['nombre', 'el nombre de quien recibe'],
  ['telefono', 'el teléfono'],
];

const pesos = n => '$' + (Number(n) || 0).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// Lo cobrado a la clienta por el envío (22-oct-2026): pesos con punto decimal y máximo 2 decimales (el servidor
// valida lo mismo). Al mandar a caja, el ticket lleva una línea "Envío" por este monto.
const MONTO_OK = /^\d{1,6}(\.\d{1,2})?$/;
const hayMonto = v => v !== undefined && v !== null && v !== '';
const montoTxt = n => (hayMonto(n) && Number.isFinite(Number(n))) ? (Math.round(Number(n) * 100) / 100).toFixed(2) : '';
// Revisión 22-oct: "30505" en vez de "305.05" saldría tal cual en el ticket. Un monto de más de $1,000 que pasa de 3
// veces la tarifa se confirma antes de guardar (solo pregunta: el monto lo decide la vendedora).
const confirmaMontoAlto = (v, tarifa) => {
  const n = Number(v), t = Number(tarifa);
  if (!(n > 1000) || !(t > 0) || n <= 3 * t) return true;
  return window.confirm('¿Seguro que a la clienta se le cobran ' + pesos(n) + ' de envío? La tarifa es ' + pesos(t) + '. Ese monto va tal cual en su ticket.');
};
const limpiaMonto = s => {
  let t = String(s || '').replace(/[^\d.]/g, '');
  const i = t.indexOf('.');
  if (i >= 0) t = t.slice(0, i + 1) + t.slice(i + 1).replace(/\./g, '').slice(0, 2);
  return t.slice(0, 9);
};

// Llama a la PWA con el mismo token que el resto de la app.
async function api(ruta, opts = {}) {
  const tok = localStorage.getItem('token');
  const r = await fetch(ruta, {
    ...opts,
    headers: { 'Content-Type': 'application/json', ...(tok ? { Authorization: 'Bearer ' + tok } : {}), ...(opts.headers || {}) },
    ...(opts.body ? { body: JSON.stringify(opts.body) } : {}),
  });
  const j = await r.json().catch(() => null);
  if (!r.ok || !j || j.ok === false) {
    const e = new Error((j && (j.error || j.message)) || ('no se pudo (HTTP ' + r.status + ')'));
    e.data = j || {};
    throw e;
  }
  return j;
}

export default function EnvioPaqueteria({ pedido, onCerrar, onGuardado }) {
  const piezas = useMemo(
    () => (pedido.lines || []).reduce((s, l) => s + (l.total_pieces || l.qty || 0), 0),
    [pedido]
  );

  const ya = pedido.envio || null;
  const [pegado, setPegado] = useState('');
  const [dir, setDir] = useState(() => ({
    nombre: (ya && ya.direccion && ya.direccion.nombre) || pedido.client_name || '',
    telefono: (ya && ya.direccion && ya.direccion.telefono) || '',
    cp: (ya && ya.direccion && ya.direccion.cp) || '',
    estado: (ya && ya.direccion && ya.direccion.estado) || '',
    municipio: (ya && ya.direccion && ya.direccion.municipio) || '',
    colonia: (ya && ya.direccion && ya.direccion.colonia) || '',
    calle: (ya && ya.direccion && ya.direccion.calle) || '',
    referencias: (ya && ya.direccion && ya.direccion.referencias) || '',
  }));
  const [colonias, setColonias] = useState(ya && ya.direccion ? [ya.direccion.colonia] : []);
  const [buscandoCp, setBuscandoCp] = useState(false);
  const [cpSugeridos, setCpSugeridos] = useState([]);
  const [peso, setPeso] = useState(() => String((ya && ya.paquete && ya.paquete.weight) || Math.max(1, Math.round(piezas * 0.4))));
  const paq0 = (ya && ya.paquete) || {};
  const [largo, setLargo] = useState(String(paq0.length || 45));
  const [ancho, setAncho] = useState(String(paq0.width || 30));
  const [alto, setAlto] = useState(String(paq0.height || 30));
  const [empaque, setEmpaque] = useState(paq0.package_type || '4G');
  const [saldo, setSaldo] = useState(null);
  const [mercancia, setMercancia] = useState('53101600');
  const [confirmando, setConfirmando] = useState(false);
  const [generando, setGenerando] = useState(false);
  // Envio "Ocurre": a donde llega el paquete y en cual sucursal lo recoge.
  const [aSucursal, setASucursal] = useState(false);
  const [sucursales, setSucursales] = useState(null);
  const [sucursal, setSucursal] = useState((ya && ya.sucursal) || null);
  const [cargandoSuc, setCargandoSuc] = useState(false);

  // Seguro (SOS Protección). Se prellena con lo que la clienta pagó: es lo que vale la caja.
  const valorPedido = useMemo(
    () => (pedido.lines || []).reduce((n, l) => n + (l.total_pieces || l.qty || 0) * (l.unit_price || 0), 0) - (Number(pedido.discount) || 0),
    [pedido]
  );
  const [asegurar, setAsegurar] = useState(!!(ya && ya.asegurado));
  const [valorDec, setValorDec] = useState(String((ya && ya.valor_declarado) || Math.round(valorPedido) || ''));
  const [tarifas, setTarifas] = useState([]);
  const [elegida, setElegida] = useState((ya && ya.tarifa) || null);
  const [cotizando, setCotizando] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [envio, setEnvio] = useState(ya);
  const [err, setErr] = useState('');
  const [aviso, setAviso] = useState('');
  const [trayendo, setTrayendo] = useState(false);
  const [candidatos, setCandidatos] = useState([]);
  const cpPedido = useRef('');
  // Cobrado al cliente por el envío (22-oct-2026). Se prellena con la tarifa elegida (lo que NOS cuesta) hasta que
  // la vendedora lo toca. Pedido sin ticket: es obligatorio y va en su ticket como línea "Envío".
  const sinTicket = pedido.status === 'pending';
  const [cobrado, setCobrado] = useState(() => (ya && hayMonto(ya.cobrado_cliente)) ? montoTxt(ya.cobrado_cliente)
    : ((ya && ya.tarifa && hayMonto(ya.tarifa.precio)) ? montoTxt(ya.tarifa.precio) : ''));
  const cobradoTocado = useRef(!!(ya && hayMonto(ya.cobrado_cliente)));
  // Con guía y sin ticket se puede cambiar aparte (PUT /cobrado); si falta, se abre ya para capturarlo.
  const [editCob, setEditCob] = useState(() => !!(ya && ya.guia && sinTicket && !hayMonto(ya.cobrado_cliente)));
  const [guardandoCob, setGuardandoCob] = useState(false);
  // 24-oct-2026 (dueño): la clienta paga el envío DIRECTO a la paquetería (Skydropx), con la cuenta que se le manda
  // desde el chat (Datos bancarios → Cuenta de paquetería). Va FUERA DE LA CAJA: lo cobrado queda en 0, el ticket no
  // lleva la línea "Envío" y el pedido queda anotado. Lo que pagó allá es opcional (solo de referencia).
  const [pagaDirecto, setPagaDirecto] = useState(() => !!(ya && ya.pagado_directo));
  const [montoDirecto, setMontoDirecto] = useState(() => (ya && ya.pagado_directo && hayMonto(ya.pagado_directo.monto)) ? montoTxt(ya.pagado_directo.monto) : '');

  const set = (k, v) => setDir(d => ({ ...d, [k]: v }));

  // Mientras no lo toquen, lo cobrado sigue a la tarifa elegida (otra zona u otra paquetería, otro precio).
  useEffect(() => {
    if (cobradoTocado.current) return;
    setCobrado(elegida && hayMonto(elegida.precio) ? montoTxt(elegida.precio) : '');
  }, [elegida]);

  // El saldo se lee al abrir: generar la guia SI cuesta, y la vendedora no debe prometerle el
  // envio a la clienta para despues descubrir que no alcanza.
  useEffect(() => {
    let vivo = true;
    api('/api/envios/saldo').then(j => { if (vivo) setSaldo(j); }).catch(() => {});
    return () => { vivo = false; };
  }, []);

  const paquete = () => ({
    length: Number(largo) || 0, width: Number(ancho) || 0, height: Number(alto) || 0,
    weight: Number(peso) || 1, package_type: empaque,
  });
  // Las paqueterias cobran el MAYOR entre el peso real y el volumetrico (largo x ancho x alto
  // entre 4500). Por eso una caja grande y ligera sale cara: se muestra para que se entienda.
  const volumetrico = useMemo(() => {
    const l = Number(largo) || 0, a = Number(ancho) || 0, h = Number(alto) || 0;
    return (l && a && h) ? Math.round((l * a * h / 4500) * 10) / 10 : 0;
  }, [largo, ancho, alto]);

  // CP completo -> estado, municipio y colonias. Se dispara solo al llegar a 5 digitos para no
  // preguntar en cada tecla.
  useEffect(() => {
    const cp = digitos(dir.cp);
    if (cp.length !== 5 || cpPedido.current === cp) return;
    cpPedido.current = cp;
    let vivo = true;
    setBuscandoCp(true); setErr(''); setCpSugeridos([]);
    api('/api/envios/cp/' + cp)
      .then(j => {
        if (!vivo) return;
        setColonias(j.colonias || []);
        setDir(d => ({
          ...d, estado: j.estado, municipio: j.municipio,
          colonia: (j.colonias || []).includes(d.colonia) ? d.colonia : ((j.colonias || []).length === 1 ? j.colonias[0] : ''),
        }));
        setTarifas([]); setElegida(null);   // otra zona, otro precio
      })
      .catch(e => {
        if (!vivo) return;
        setErr(e.message); setColonias([]);
        setCpSugeridos((e.data && e.data.sugerencias) || []);
      })
      .finally(() => { if (vivo) setBuscandoCp(false); });
    return () => { vivo = false; };
  }, [dir.cp]);

  const leer = async () => {
    setErr('');
    try {
      const j = await api('/api/envios/pegado', { method: 'POST', body: { texto: pegado } });
      if (!j.cp && !j.telefono) { setErr('No encontré código postal ni teléfono en ese mensaje; captúralos abajo.'); return; }
      setDir(d => ({ ...d, cp: j.cp || d.cp, telefono: j.telefono || d.telefono }));
      setAviso('Saqué' + (j.cp ? ' el código postal' : '') + (j.cp && j.telefono ? ' y' : '') + (j.telefono ? ' el teléfono' : '') +
        '. El nombre, la calle y el número acomódalos tú viendo el mensaje: adivinarlos manda el paquete a otro lado.');
    } catch (e) { setErr(e.message); }
  };

  const faltaSucursal = () => aSucursal && !(sucursal && sucursal.id);

  // Lo que falta, CAMPO POR CAMPO, para poder marcarle el contorno al que le toca en vez de solo
  // decirlo arriba. Se calcula al intentar cotizar o guardar, no mientras teclea: marcar todo en
  // rojo antes de que empiece a llenar no ayuda a nadie.
  const [faltan, setFaltan] = useState({});

  // `claves` limita lo que se MARCA en rojo, aunque siempre se revise todo: para cotizar basta
  // la zona, y marcarle el nombre y la calle cuando solo pidio un precio nada mas estorba.
  const revisar = (claves) => {
    const f = {};
    for (const [k] of CAMPOS) { if (!String(dir[k] || '').trim()) { f[k] = true; } }
    if (!f.telefono && digitos(dir.telefono).length < 10) { f.telefono = 'incompleto'; }
    if (faltaSucursal()) { f.sucursal = true; }
    if (asegurar && !(Number(valorDec) > 0)) { f.valor = true; }
    // Sin ticket es obligatorio (va en el ticket); con ticket, si lo escriben, que sea un monto.
    // Pagado directo a la paquetería: no hay nada que cobrar aquí; lo que pagó allá es opcional.
    if (pagaDirecto) {
      const md = montoDirecto.trim();
      if (md && !MONTO_OK.test(md)) { f.montoDirecto = 'invalido'; }
    } else {
      const cob = cobrado.trim();
      if (cob ? !MONTO_OK.test(cob) : sinTicket) { f.cobrado = cob ? 'invalido' : true; }
    }
    setFaltan(claves
      ? Object.fromEntries(Object.entries(f).filter(([k]) => claves.includes(k)))
      : f);
    return f;
  };

  // En cuanto llena uno, se le quita la marca sola: la vendedora ve el avance.
  useEffect(() => {
    setFaltan(f => {
      if (!Object.keys(f).length) return f;
      const n = { ...f };
      for (const [k] of CAMPOS) { if (String(dir[k] || '').trim()) { delete n[k]; } }
      if (digitos(dir.telefono).length === 10) { delete n.telefono; }
      if (sucursal && sucursal.id) { delete n.sucursal; }
      if (Number(valorDec) > 0) { delete n.valor; }
      if (MONTO_OK.test(cobrado.trim()) || pagaDirecto) { delete n.cobrado; }
      if (!montoDirecto.trim() || MONTO_OK.test(montoDirecto.trim()) || !pagaDirecto) { delete n.montoDirecto; }
      return n;
    });
  }, [dir, sucursal, valorDec, cobrado, pagaDirecto, montoDirecto]);

  const textoFalta = (f) => {
    const l = CAMPOS.filter(([k]) => f[k]).map(([, etq]) => etq);
    if (f.sucursal) l.push('la sucursal');
    if (f.valor) l.push('cuánto vale lo que aseguras');
    if (f.cobrado) l.push(f.cobrado === 'invalido' ? 'lo cobrado por el envío como número (ej. 305.05)' : 'cuánto se le cobra a la clienta por el envío (0 si no se le cobra)');
    if (f.montoDirecto) l.push('lo que pagó a la paquetería como número (ej. 250.00), o déjalo vacío');
    if (!l.length) return '';
    if (f.telefono === 'incompleto' && l.length === 1) return 'El teléfono debe traer 10 números.';
    return 'Falta ' + (l.length === 1 ? l[0] : l.slice(0, -1).join(', ') + ' y ' + l[l.length - 1]) + '.';
  };
  const cls = (k, base) => base + (faltan[k] ? ' falta' : '');

  const cotizar = async () => {
    const f = revisar(['cp', 'colonia']);
    if (f.cp || f.colonia) { setErr(textoFalta({ cp: f.cp, colonia: f.colonia })); return; }
    setErr(''); setAviso(''); setCotizando(true); setTarifas([]); setElegida(null);
    try {
      const j = await api('/api/envios/' + pedido.id + '/cotizar', {
        method: 'POST', body: { direccion: dir, paquete: paquete() },
      });
      setTarifas(j.tarifas || []);
      if (!(j.tarifas || []).length) setErr('Ninguna paquetería cotizó a ese código postal.');
      else if (!j.completa) setAviso('Algunas paqueterías no alcanzaron a contestar; vuelve a cotizar si esperabas más opciones.');
    } catch (e) { setErr(e.message); }
    finally { setCotizando(false); }
  };

  // Al tocar una tarifa: si esa paqueteria SOLO entrega en sucursal, no hay de otra y se cargan
  // las sucursales de una vez. Si entrega de las dos formas, se deja elegir.
  const elegir = (t) => {
    setElegida(t);
    setSucursal(null); setSucursales(null);
    const forzada = t.entrega === 'sucursal';
    setASucursal(forzada);
    if (forzada) cargarSucursales(t);
  };

  const cargarSucursales = async (t) => {
    const tar = t || elegida;
    if (!tar || !tar.id) return;
    setCargandoSuc(true); setErr('');
    try {
      const j = await api('/api/envios/sucursales?rate=' + encodeURIComponent(tar.id));
      setSucursales(j.sucursales || []);
      if (!(j.sucursales || []).length) setErr('Esa paquetería no tiene sucursales para ese destino; escoge otra opción.');
    } catch (e) { setErr(e.message); setSucursales([]); }
    finally { setCargandoSuc(false); }
  };

  const guardar = async () => {
    const f = revisar();
    if (Object.keys(f).length) { setErr(textoFalta(f)); return; }
    if (!pagaDirecto && !confirmaMontoAlto(cobrado.trim(), elegida && elegida.precio)) return;
    setErr(''); setAviso(''); setGuardando(true);
    try {
      const cobro = pagaDirecto
        ? { cobrado_cliente: '0', pagado_directo: { monto: montoDirecto.trim() === '' ? null : montoDirecto.trim() } }
        : { cobrado_cliente: cobrado.trim() === '' ? null : cobrado.trim(), pagado_directo: false };
      const j = await api('/api/envios/' + pedido.id, {
        method: 'POST', body: { direccion: dir, paquete: paquete(), tarifa: elegida, sucursal: aSucursal ? sucursal : null, ...cobro },
      });
      setEnvio(j.envio);
      if (j.envio && hayMonto(j.envio.cobrado_cliente)) cobradoTocado.current = true;   // ya guardado: no lo mueve otra tarifa
      const partes = [];
      if (j.envio && j.envio.pagado_directo) partes.push('El envío lo paga la clienta directo a la paquetería: va fuera de la caja y su ticket no lleva la línea “Envío”.');
      partes.push(j.odoo && j.odoo.ok ? 'La dirección quedó guardada en el cliente: el próximo envío ya sale sin volver a pedirla.'
                                      : 'El envío quedó guardado, pero la dirección NO se pudo guardar en el cliente de Odoo' + (j.odoo && j.odoo.error ? ' (' + j.odoo.error + ')' : '') + '.');
      partes.push(j.error_skydropx ? 'No se pudo subir a Skydropx (' + j.error_skydropx + '); la dirección ya está guardada, vuelve a intentar.'
                                   : 'El pedido ya está cargado en Skydropx: entra a generar la guía y luego toca "Traer la guía".');
      setAviso(partes.join(' '));
      if (onGuardado) onGuardado(j.envio);
    } catch (e) { setErr(e.message); }
    finally { setGuardando(false); }
  };

  // GENERAR LA GUIA. Es lo unico de esta pantalla que gasta dinero, por eso va con confirmacion
  // y con el boton bloqueado mientras corre: un segundo toque no debe cobrar otra vez.
  const generar = async () => {
    setErr(''); setAviso(''); setConfirmando(false); setGenerando(true);
    try {
      const j = await api('/api/envios/' + pedido.id + '/generar', { method: 'POST', body: { mercancia, asegurar, valor_declarado: asegurar ? (Number(valorDec) || 0) : 0 } });
      if (j.envio) { setEnvio(j.envio); if (onGuardado) onGuardado(j.envio); }
      setAviso(j.ya_estaba ? 'Ese pedido ya tenía guía; no se generó otra.' : 'Guía generada. Ya se puede imprimir y rastrear.');
      api('/api/envios/saldo').then(x => setSaldo(x)).catch(() => {});
    } catch (e) { setErr(e.message); }
    finally { setGenerando(false); }
  };

  const traerGuia = async () => {
    setErr(''); setTrayendo(true);
    try {
      const j = await api('/api/envios/' + pedido.id + '/guia', { method: 'POST' });
      if (j.envio) { setEnvio(j.envio); if (onGuardado) onGuardado(j.envio); }
      setCandidatos([]);
      setAviso('Guía ' + j.envio.guia + (j.envio.paqueteria ? ' (' + j.envio.paqueteria + ')' : '') + ' guardada en el pedido.');
    } catch (e) {
      setErr(e.message);
      setCandidatos((e.data && e.data.candidatos) || []);
    }
    finally { setTrayendo(false); }
  };

  // Cambiar SOLO lo cobrado (con la guía ya hecha y el pedido sin ticket): PUT /api/envios/:id/cobrado.
  const guardarCobrado = async () => {
    const v = cobrado.trim();
    let body;
    if (pagaDirecto) {
      const md = montoDirecto.trim();
      if (md && !MONTO_OK.test(md)) {
        setFaltan(f => ({ ...f, montoDirecto: 'invalido' }));
        setErr(textoFalta({ montoDirecto: 'invalido' }));
        return;
      }
      body = { pagado_directo: { monto: md === '' ? null : md } };
    } else {
      if (!MONTO_OK.test(v)) {
        setFaltan(f => ({ ...f, cobrado: v ? 'invalido' : true }));
        setErr(textoFalta({ cobrado: v ? 'invalido' : true }));
        return;
      }
      if (!confirmaMontoAlto(v, envio && envio.tarifa && envio.tarifa.precio)) return;
      body = { cobrado_cliente: v, pagado_directo: false };
    }
    setErr(''); setAviso(''); setGuardandoCob(true);
    try {
      const j = await api('/api/envios/' + pedido.id + '/cobrado', { method: 'PUT', body });
      if (j.envio) { setEnvio(j.envio); if (onGuardado) onGuardado(j.envio); }
      cobradoTocado.current = true;
      setEditCob(false);
      if (j.envio && j.envio.pagado_directo) {
        setCobrado('0.00');
        setAviso('Quedó: la clienta paga el envío directo a la paquetería, fuera de la caja' +
          (sinTicket ? '. Su ticket no lleva la línea "Envío".' : '.') + (j.aviso_espejo ? ' ' + j.aviso_espejo : ''));
      } else {
        setAviso('Quedó: el envío se le cobra ' + pesos(j.envio ? j.envio.cobrado_cliente : v) +
          (sinTicket ? '. Al mandar el pedido a caja, su ticket lleva la línea "Envío" por ese monto.' : '.') +
          (j.aviso_espejo ? ' ' + j.aviso_espejo : ''));
      }
    } catch (e) { setErr(e.message); }
    finally { setGuardandoCob(false); }
  };

  // La guia pudo generarse DIAS antes de capturar el envio aqui. En ese caso la vendedora la
  // reconoce en la lista y la engancha; el sistema no la adivina solo.
  const usarEsta = async (c) => {
    setErr(''); setTrayendo(true);
    try {
      const j = await api('/api/envios/' + pedido.id + '/guia-elegida', { method: 'POST', body: { guia_elegida: c } });
      if (j.envio) { setEnvio(j.envio); if (onGuardado) onGuardado(j.envio); }
      setCandidatos([]);
      setAviso('Guía ' + c.guia + ' enganchada a este pedido.');
    } catch (e) { setErr(e.message); }
    finally { setTrayendo(false); }
  };

  // EnvioClienta solo cambia la cuenta enlazada. Va con actualizador y no con el `envio` de este render: la tienda
  // puede tardar y, si mientras tanto se guardo lo cobrado, ese monto se perderia.
  const cambioClienta = (parche) => {
    setEnvio(e => ({ ...e, ...parche }));
    if (onGuardado) onGuardado({ ...envio, ...parche });
  };

  const conGuia = envio && envio.guia;
  const cobradoGuardado = envio && hayMonto(envio.cobrado_cliente) ? envio.cobrado_cliente : null;
  // Revisión 22-oct: el envío YA va en el ticket con ese monto (en_ticket): ya no se cambia desde aquí.
  const enTicket = (envio && envio.en_ticket) || null;
  const puedeCambiarCob = sinTicket && !enTicket;
  const pdGuardado = (envio && envio.pagado_directo) || null;   // 24-oct: pagado directo a la paquetería
  // El interruptor "paga directo a la paquetería" (mismo estilo que el del seguro).
  const switchDirecto = (
    <div className="ep-seg" data-ep="paga-directo">
      <span className="t">
        <b>La clienta paga el envío directo a la paquetería (Skydropx)</b>
        <small>Deposita a la cuenta de la paquetería (en el chat: Datos bancarios → Cuenta de paquetería). No entra a la caja: el ticket no lleva la línea “Envío”.</small>
      </span>
      <button type="button" className={'ep-sw' + (pagaDirecto ? ' on' : '')} role="switch" aria-checked={pagaDirecto} disabled={!!enTicket}
        aria-label="La clienta paga el envío directo a la paquetería" onClick={() => setPagaDirecto(v => !v)}><span className="b" /></button>
    </div>
  );
  const campoDirecto = (id) => (<>
    <label className="c2-fl" htmlFor={id}>LO QUE PAGÓ A LA PAQUETERÍA (OPCIONAL)</label>
    <input id={id} className={cls('montoDirecto', 'c2-in')} inputMode="decimal" value={montoDirecto} placeholder="0.00"
      onChange={e => setMontoDirecto(limpiaMonto(e.target.value))} />
    <p className="ep-nota">Solo de referencia: ese dinero se vuelve saldo de Skydropx para la guía y no pasa por la caja. El pedido queda anotado como <b>envío pagado directo a la paquetería</b>.</p>
  </>);

  return (
    <div className="c2-sheet" role="dialog" aria-modal="true" aria-label="Enviar por paquetería">
      <style>{CSS}</style>
      <div className="c2-sh-top">
        <button type="button" className="c2-ib" aria-label="Cerrar" onClick={onCerrar}>✕</button>
        <div className="c2-sh-t">Enviar por paquetería<small>{pedido.client_name || 'Sin cliente'} · {piezas} pz{sinTicket ? ' · aún sin ticket' : ''}</small></div>
      </div>

      <div className="c2-sh-body">
        {saldo && saldo.ok && (
          <div className={'ep-saldo' + (saldo.saldo < 200 ? ' bajo' : '')}>
            <span>Saldo en Skydropx{saldo.saldo < 200 ? ' — alcanza para pocas guías' : ''}</span>
            <b>{pesos(saldo.saldo)}</b>
          </div>
        )}
        {err && <div className="c2-err" role="alert">{err}</div>}
        {aviso && <div className="ep-ok">{aviso}</div>}
        {candidatos.length > 0 && !conGuia && (
          <div className="ep-suc">
            <h4>¿Es alguna de estas?</h4>
            <p className="ep-nota" style={{ margin: 0 }}>
              Guías de ese teléfono en Skydropx. Si la mandaste antes de capturar el envío aquí, tócala para engancharla.
            </p>
            {candidatos.map(c => (
              <button type="button" key={c.envio_id} className="ep-s" disabled={trayendo} onClick={() => usarEsta(c)}>
                <b>{(c.paqueteria || '').toUpperCase()} {c.guia}</b>
                <small>{c.nombre}{c.cp ? ' · CP ' + c.cp : ''}
                  {c.fecha ? ' · ' + new Date(c.fecha).toLocaleDateString('es-MX', { day: 'numeric', month: 'short' }) : ''}
                  {c.costo ? ' · ' + pesos(c.costo) : ''}</small>
              </button>
            ))}
          </div>
        )}

        {conGuia ? (
          <div className="ep-guia">
            <small style={{ color: '#64748B', fontSize: 12 }}>Guía {envio.paqueteria ? '· ' + envio.paqueteria : ''}</small>
            <b>{envio.guia}</b>
            {envio.etiqueta_url && (
              <a className="c2-btn" href={envio.etiqueta_url} target="_blank" rel="noreferrer"
                style={{ display: 'block', textAlign: 'center', textDecoration: 'none', margin: '10px 0 2px' }}>
                Abrir la etiqueta para imprimir
              </a>
            )}
            <RastreoEnvio pedidoId={pedido.id} envio={envio} />
            {/* key: otro espejo es otra liga; la que ya estaba copiada no debe sobrevivir al cambio. */}
            <EnvioClienta key={envio.espejo_wc || 'sin-espejo'} pedidoId={pedido.id} envio={envio} onCambio={cambioClienta} />
            {envio.costo_real != null && <p className="ep-nota">Costó {pesos(envio.costo_real)}{envio.asegurado ? ', ya con el seguro' : ''}.</p>}
            {envio.asegurado && <p className="ep-nota">Asegurado por {pesos(envio.valor_declarado)}.</p>}
            {editCob ? (<>
              {switchDirecto}
              {pagaDirecto ? campoDirecto('ep-pdm2') : (<>
              <label className="c2-fl" htmlFor="ep-cob2">COBRADO A LA CLIENTA POR EL ENVÍO</label>
              <input id="ep-cob2" className={cls('cobrado', 'c2-in')} inputMode="decimal" value={cobrado} placeholder="0.00"
                onChange={e => { cobradoTocado.current = true; setCobrado(limpiaMonto(e.target.value)); }} />
              <p className="ep-nota">
                {cobradoGuardado == null && envio.tarifa && hayMonto(envio.tarifa.precio) && <>Viene prellenado con la tarifa ({pesos(envio.tarifa.precio)}), que es lo que NOS cuesta: cámbialo si a la clienta se le cobró otro monto. </>}
                Al mandar el pedido a caja, su ticket lleva una línea <b>“Envío”</b> por este monto. 0 = no se le cobra.
              </p>
              </>)}
              <div className="c3-2b" style={{ marginTop: 8 }}>
                {cobradoGuardado != null && <button type="button" className="c2-btn ghost" disabled={guardandoCob}
                  onClick={() => { setEditCob(false); setCobrado(montoTxt(cobradoGuardado)); setPagaDirecto(!!pdGuardado);
                    setMontoDirecto(pdGuardado && hayMonto(pdGuardado.monto) ? montoTxt(pdGuardado.monto) : ''); }}>Cancelar</button>}
                <button type="button" className="c2-btn" onClick={guardarCobrado} disabled={guardandoCob}>{guardandoCob ? 'Guardando…' : (pagaDirecto ? 'Guardar' : 'Guardar lo cobrado')}</button>
              </div>
            </>) : (
              <div className="ep-cob">
                <span>
                  <small>{pdGuardado ? 'Envío pagado directo a la paquetería' : 'Cobrado a la clienta por el envío'}</small>
                  <b>{pdGuardado ? (hayMonto(pdGuardado.monto) ? pesos(pdGuardado.monto) + ' a Skydropx' : 'Fuera de la caja')
                    : (cobradoGuardado != null ? pesos(cobradoGuardado) : 'Sin capturar')}</b>
                </span>
                {puedeCambiarCob && <button type="button" className="c2-btn ghost" onClick={() => setEditCob(true)}>Cambiar</button>}
              </div>
            )}
            {!editCob && <p className="ep-nota">{enTicket
              ? 'Ya va en el ticket' + (enTicket.ticket ? ' ' + enTicket.ticket : '') + ' como línea “Envío” por ' + pesos(enTicket.monto) + '.'
              : pdGuardado
              ? 'La clienta pagó el envío directo a la paquetería: va fuera de la caja' + (sinTicket ? ' y su ticket no lleva la línea “Envío”.' : '.')
              : sinTicket
              ? (cobradoGuardado != null ? 'Este pedido aún no tiene ticket: al mandarlo a caja lleva la línea “Envío” por este monto.'
                : 'Falta capturarlo: sin este monto el pedido no se puede mandar a caja.')
              : 'Este pedido ya tiene ticket: lo cobrado por el envío no se agrega solo a ese ticket.'}</p>}
            {envio.sucursal && (
              <p className="ep-nota"><b>Lo recoge en:</b> {envio.sucursal.nombre} — {envio.sucursal.direccion}
                {envio.sucursal.mapa && <> · <a href={envio.sucursal.mapa} target="_blank" rel="noreferrer">ver en el mapa</a></>}
              </p>
            )}
            {envio.espejo_wc
              ? <p className="ep-nota">Ya se puede rastrear. En la tienda es el pedido <strong>#{envio.espejo_numero || envio.espejo_wc}</strong>.</p>
              : <p className="ep-nota">Ya se puede rastrear. {envio.error_espejo
                  ? "Falta reflejarlo en la tienda para que salga en la app (" + envio.error_espejo + "): vuelve a tocar “Traer la guía”."
                  : "Falta reflejarlo en la tienda para que salga en la app."}</p>}
          </div>
        ) : (<>
          <p className="ep-paso">PASO 1 · DIRECCIÓN</p>
          <label className="c2-fl" htmlFor="ep-pg">PEGA EL MENSAJE DE LA CLIENTA</label>
          <textarea id="ep-pg" className="ep-ta" value={pegado} onChange={e => setPegado(e.target.value)}
            placeholder="Pega aquí tal cual lo que te mandó por WhatsApp" />
          <button type="button" className="c2-btn ghost" style={{ marginTop: 8 }} onClick={leer} disabled={!pegado.trim()}>
            Sacar código postal y teléfono
          </button>

          <div className="ep-row" style={{ marginTop: 4 }}>
            <div>
              <label className="c2-fl" htmlFor="ep-cp">CÓDIGO POSTAL</label>
              <input id="ep-cp" className={cls('cp', "c2-in")} inputMode="numeric" maxLength={5} value={dir.cp}
                onChange={e => set('cp', digitos(e.target.value).slice(0, 5))} />
            </div>
            <div>
              <label className="c2-fl" htmlFor="ep-tel">TELÉFONO</label>
              <input id="ep-tel" className={cls('telefono', "c2-in")} inputMode="numeric" maxLength={10} value={dir.telefono}
                onChange={e => set('telefono', digitos(e.target.value).slice(0, 10))} />
            </div>
          </div>
          {buscandoCp && <p className="ep-nota">Buscando ese código postal…</p>}
          {cpSugeridos.length > 0 && (
            <div className="ep-suc">
              <h4>Ese código postal no existe</h4>
              <p className="ep-nota" style={{ margin: 0 }}>
                Puede traer un dígito cambiado. Estos sí existen y se parecen — confírmale a la clienta cuál es el suyo:
              </p>
              {cpSugeridos.map(x => (
                <button type="button" key={x.cp} className="ep-s" onClick={() => { setCpSugeridos([]); set('cp', x.cp); }}>
                  <b>{x.cp}</b><small>{x.municipio}, {x.estado} · {x.colonias} colonia{x.colonias === 1 ? '' : 's'}</small>
                </button>
              ))}
            </div>
          )}

          <label className="c2-fl">ESTADO Y MUNICIPIO</label>
          <div className="ep-ro">{dir.estado ? dir.estado + ' · ' + dir.municipio : 'Se llenan solos con el código postal'}</div>

          <label className="c2-fl" htmlFor="ep-col">COLONIA</label>
          <select id="ep-col" className={cls('colonia', "c2-in")} value={dir.colonia} onChange={e => set('colonia', e.target.value)} disabled={!colonias.length}>
            <option value="">{colonias.length ? 'Elige la colonia' : 'Primero el código postal'}</option>
            {colonias.map(c => <option key={c} value={c}>{c}</option>)}
          </select>

          <label className="c2-fl" htmlFor="ep-calle">CALLE Y NÚMERO</label>
          <input id="ep-calle" className={cls('calle', "c2-in")} value={dir.calle} onChange={e => set('calle', e.target.value)}
            placeholder="Av. Juárez 125, int. 3" />

          <label className="c2-fl" htmlFor="ep-nom">QUIÉN RECIBE</label>
          <input id="ep-nom" className={cls('nombre', "c2-in")} value={dir.nombre} onChange={e => set('nombre', e.target.value)} />

          <label className="c2-fl" htmlFor="ep-ref">REFERENCIAS (OPCIONAL)</label>
          <input id="ep-ref" className="c2-in" value={dir.referencias} onChange={e => set('referencias', e.target.value)}
            placeholder="Entre qué calles, color de la casa…" />

          <p className="ep-paso">PASO 2 · PAQUETE Y PRECIO</p>

          <label className="c2-fl" htmlFor="ep-emp">TIPO DE EMPAQUE</label>
          <select id="ep-emp" className="c2-in" value={empaque} onChange={e => { setEmpaque(e.target.value); setTarifas([]); setElegida(null); }}>
            {EMPAQUES.map(x => <option key={x.codigo} value={x.codigo}>{x.nombre}</option>)}
          </select>

          <label className="c2-fl" htmlFor="ep-merc">QUÉ VA DENTRO</label>
          <select id="ep-merc" className="c2-in" value={mercancia} onChange={e => setMercancia(e.target.value)}>
            {MERCANCIAS.map(x => <option key={x.codigo} value={x.codigo}>{x.nombre}</option>)}
          </select>
          <p className="ep-nota">Lo que más haya en la caja. Va en la Carta Porte de la guía.</p>

          <label className="c2-fl">MEDIDAS DE LA CAJA (CM)</label>
          <div className="ep-row3">
            <input className="c2-in" inputMode="decimal" aria-label="Largo en centímetros" placeholder="Largo"
              value={largo} onChange={e => setLargo(e.target.value.replace(/[^\d.]/g, ''))} />
            <input className="c2-in" inputMode="decimal" aria-label="Ancho en centímetros" placeholder="Ancho"
              value={ancho} onChange={e => setAncho(e.target.value.replace(/[^\d.]/g, ''))} />
            <input className="c2-in" inputMode="decimal" aria-label="Alto en centímetros" placeholder="Alto"
              value={alto} onChange={e => setAlto(e.target.value.replace(/[^\d.]/g, ''))} />
          </div>
          <p className="ep-nota">Largo × ancho × alto.</p>

          <label className="c2-fl" htmlFor="ep-peso">PESO (KG)</label>
          <input id="ep-peso" className="c2-in" inputMode="decimal" value={peso}
            onChange={e => setPeso(e.target.value.replace(/[^\d.]/g, ''))} />
          <p className="ep-nota">
            Sugerido por las {piezas} piezas (~0.4 kg cada una). <b>Ajústalo si pesaste la caja</b>:
            la paquetería cobra por lo que de verdad mandas.
            {volumetrico > 0 && <> Con esas medidas el <b>peso volumétrico es {volumetrico} kg</b>
              {volumetrico > (Number(peso) || 0)
                ? ' — varias paqueterías van a cobrar por ese, no por el real.'
                : ' , menos que el real, así que cobran por el peso.'}</>}
          </p>

          <div className="ep-seg">
            <span className="t">
              <b>Asegurar el paquete</b>
              <small>Si se pierde o lo dañan, te lo reponen hasta el valor que declares.</small>
            </span>
            <button type="button" className={'ep-sw' + (asegurar ? ' on' : '')} role="switch" aria-checked={asegurar}
              aria-label="Asegurar el paquete" onClick={() => setAsegurar(v => !v)}><span className="b" /></button>
          </div>
          {asegurar && (<>
            <label className="c2-fl" htmlFor="ep-val">CUÁNTO VALE LO QUE VA DENTRO</label>
            <input id="ep-val" className={cls('valor', "c2-in")} inputMode="decimal" value={valorDec}
              onChange={e => setValorDec(e.target.value.replace(/[^\d.]/g, ''))} />
            <p className="ep-nota">
              Viene de lo que pagó la clienta ({pesos(valorPedido)}). <b>El seguro se cobra aparte</b>:
              no va incluido en los precios de abajo, y el cobro real se ve cuando la guía ya está hecha.
            </p>
          </>)}

          <button type="button" className="c2-btn" style={{ marginTop: 12 }} onClick={cotizar} disabled={cotizando || buscandoCp}>
            {cotizando ? 'Cotizando… (tarda hasta 30 s)' : 'Cotizar'}
          </button>

          {tarifas.length > 0 && (
            <div className="ep-tar">
              <p className="ep-nota" style={{ marginBottom: 2 }}>De la entrega más rápida a la más lenta. Toca la que escogió la clienta.</p>
              {tarifas.map(t => (
                <button type="button" key={t.id || (t.clave + t.servicio)}
                  className={'ep-t' + (elegida && elegida.id === t.id ? ' on' : '')}
                  onClick={() => elegir(t)}>
                  <span className="ep-dias"><b>{t.dias != null && t.dias !== '' ? t.dias : '—'}</b><small>{t.dias === 1 ? 'DÍA' : 'DÍAS'}</small></span>
                  <span className="d">
                    <b>{t.paqueteria}</b><small>{t.servicio}</small>
                    <span className="ep-chips">
                      <span className={'ep-chip' + (t.entrega === 'sucursal' ? ' ojo' : '')}>{ENTREGA[t.entrega] || 'Entrega a domicilio'}</span>
                      <span className="ep-chip">{RECOLECCION[t.recoleccion] || 'Tú la llevas'}</span>
                      {t.llevar_sucursal && t.recoleccion !== 'si' && <span className="ep-chip">Se deja en sucursal</span>}
                      {t.min_paquetes > 1 && <span className="ep-chip ojo">Mínimo {t.min_paquetes} paquetes</span>}
                    </span>
                  </span>
                  <span className="p"><b>{pesos(t.precio)}</b><small>{t.peso_cobrado ? 'cobra ' + t.peso_cobrado + ' kg' : 'envío'}</small></span>
                </button>
              ))}
            </div>
          )}

          {elegida && (elegida.entrega === 'sucursal' || elegida.entrega === 'ambas') && (
            <div className={cls('sucursal', "ep-suc")}>
              <h4>¿A dónde le llega el paquete?</h4>
              {elegida.entrega === 'sucursal'
                ? <p className="ep-nota" style={{ margin: 0 }}>{elegida.paqueteria} <b>solo entrega en sucursal</b>: la clienta va por él. Escoge a cuál.</p>
                : <p className="ep-nota" style={{ margin: 0 }}>{elegida.paqueteria} puede llevárselo a su casa o dejarlo en una sucursal.</p>}

              {elegida.entrega === 'ambas' && (
                <div className="op">
                  <button type="button" className={!aSucursal ? 'on' : ''} onClick={() => { setASucursal(false); setSucursal(null); }}>A su casa</button>
                  <button type="button" className={aSucursal ? 'on' : ''} onClick={() => { setASucursal(true); if (!sucursales) cargarSucursales(); }}>A una sucursal</button>
                </div>
              )}

              {aSucursal && (<>
                {cargandoSuc && <p className="ep-nota">Buscando sucursales cerca de ella…</p>}
                {sucursales && sucursales.length > 0 && (<>
                  <p className="ep-nota" style={{ marginTop: 8 }}>
                    De la más cercana a su código postal a la más lejana. <b>Léele la dirección completa</b>:
                    la más cercana no siempre le queda cómoda.
                  </p>
                  {sucursales.map(x => (
                    <button type="button" key={x.id} className={'ep-s' + (sucursal && sucursal.id === x.id ? ' on' : '')}
                      onClick={() => setSucursal(x)}>
                      <b>{x.nombre}</b><small>{x.direccion}</small>
                    </button>
                  ))}
                </>)}
              </>)}
            </div>
          )}

          {switchDirecto}
          {pagaDirecto ? campoDirecto('ep-pdm') : (<>
          <label className="c2-fl" htmlFor="ep-cob">COBRADO A LA CLIENTA POR EL ENVÍO</label>
          <input id="ep-cob" className={cls('cobrado', 'c2-in')} inputMode="decimal" value={cobrado} disabled={!!enTicket}
            placeholder={elegida && hayMonto(elegida.precio) ? montoTxt(elegida.precio) : '0.00'}
            onChange={e => { cobradoTocado.current = true; setCobrado(limpiaMonto(e.target.value)); }} />
          <p className="ep-nota">
            Lo que paga la clienta por el envío; se prellena con la tarifa elegida, que es lo que <b>nos</b> cuesta.
            {enTicket
              ? <> Ya va en el ticket{enTicket.ticket ? ' ' + enTicket.ticket : ''} por <b>{pesos(enTicket.monto)}</b>: no se cambia desde aquí.</>
              : sinTicket
              ? <> Este pedido aún no tiene ticket: <b>al mandarlo a caja, su ticket lleva una línea “Envío” por este monto</b>. 0 = no se le cobra.</>
              : <> Este pedido ya tiene ticket: este monto no se agrega solo a ese ticket.</>}
          </p>
          </>)}

        </>)}
      </div>

      {!conGuia && (
        <div className="c2-sh-foot">
          <div className="c3-2b" style={{ width: '100%' }}>
            <button type="button" className="c2-btn ghost" onClick={onCerrar}>Cerrar</button>
            <button type="button" className="c2-btn" onClick={guardar} disabled={guardando}>
              {guardando ? 'Guardando…' : (envio ? 'Guardar cambios' : 'Guardar envío')}
            </button>
          </div>
        </div>
      )}
      {envio && !conGuia && (
        <div className="c2-sh-foot">
          {confirmando ? (
            <div style={{ width: '100%' }}>
              <p className="ep-nota" style={{ margin: '0 0 8px' }}>
                Se van a cobrar <b>{pesos((envio.tarifa && envio.tarifa.precio) || 0)}</b> de tu saldo de Skydropx
                {saldo && saldo.ok && <> y te quedarían {pesos(saldo.saldo - ((envio.tarifa && envio.tarifa.precio) || 0))}</>}.
                La guía ya no se cancela desde aquí.
              </p>
              <div className="c3-2b">
                <button type="button" className="c2-btn ghost" onClick={() => setConfirmando(false)}>Cancelar</button>
                <button type="button" className="c2-btn" onClick={generar}>Sí, generar</button>
              </div>
            </div>
          ) : (
            <div style={{ width: '100%' }}>
              <button type="button" className="c2-btn" style={{ width: '100%' }} disabled={generando || !envio.tarifa}
                onClick={() => setConfirmando(true)}>
                {generando ? 'Generando la guía…' : 'Generar la guía' + (envio.tarifa ? ' · ' + pesos(envio.tarifa.precio) : '')}
              </button>
              <button type="button" className="c2-btn ghost" style={{ width: '100%', marginTop: 8 }} onClick={traerGuia} disabled={trayendo || generando}>
                {trayendo ? 'Buscando la guía…' : 'Ya la generé en Skydropx: traerla'}
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
